export const GET_ALL_ROLES_LOADING = "GET_ALL_ROLES_LOADING"
export const GET_ALL_ROLES_SUCCESS = "GET_ALL_ROLES_SUCCESS"
export const GET_ALL_MODULES_LOADING = "GET_ALL_MODULES_LOADING"
export const GET_ALL_MODULES_SUCCESS = "GET_ALL_MODULES_SUCCESS"
export const ADD_NEW_ROLE = "ADD_NEW_ROLE"
export const UPDATE_USER_ROLE = "UPDATE_USER_ROLE"
export const DELETE_USER_ROLE = "DELETE_USER_ROLE"
export const GET_USER_ROLE = "GET_USER_ROLE"
export const RESET_USER_ROLE="RESET_USER_ROLE"
